<div class="modal-container" data-cy="web-app-update-available">
  <div class="title">{{ 'PWA_alert_update_header' | translate }}</div>
  <div class="description">{{ 'PWA_alert_update_subtitle' | translate }}</div>
  <ion-spinner name="circular"></ion-spinner>
</div>
